import Layout from 'views/layout/Layout';

export default Layout;
